var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProspectIntermediate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 99,
    viewBox: "0 0 85 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.5,
    cy: 41,
    fill: "#40516F",
    rx: 2.5,
    ry: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64CFE9",
    fillRule: "nonzero",
    d: "M53.841 57.976c21.469 1.145 29.642 7.027 30.447 7.3l.51-10.649c-2.499-2.52-27.776-15.663-30.957-17.38l-.567 13.17.567-13.17c-.795-14.203-2.953-20.616-2.953-20.616C48.548 9.494 46.428.977 40.682.977c-5.981 0-10.013 16.685-10.013 16.685-1.022 4.123-1.25 11.109-1.25 18.897C24.877 39.537 2.727 53.968.569 56.602l.795 10.307s8.746-6.986 28.852-10.193c.909 14.202 3.735 28.304 4.83 30.518l7.097-2.737 7.16 2.737c2.383-11.256 4.199-21.813 4.54-29.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9EEF7",
    fillRule: "nonzero",
    d: "M54.565 54.745l-.64-20.6-1.185 12.037 1.185-12.037c-.73-12.978-3.374-18.363-3.374-18.84 0 0-3.37-14.305-9.365-14.305-.117 0 .147 27.457.79 82.371l7.915 1.775c1.457-6.857 3.016-16.991 4.674-30.401z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F12C3E",
    fillRule: "nonzero",
    d: "M55.706 89.361c-3.533-3.163-8.016-5.267-13.45-6.311-6.76 2.573-11.282 4.95-13.565 7.131-2.284 2.181-3.517 5.302-3.701 9.36l17.379-6.756 17.15 6.757c.991-3.623-.28-7.017-3.813-10.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0082A9",
    d: "M34.835 16.527c.995-4.54 3.104-6.883 6.327-7.031 3.223-.148 5.49 2.196 6.801 7.03-1.852-2.113-4.122-3.19-6.81-3.232-2.687-.041-4.793 1.036-6.318 3.233z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64CFE9",
    d: "M41.172 80H42.5l.257 13.09-.966 2.91-.967-2.498z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAA9E",
    fillRule: "nonzero",
    d: "M54 37v21.114c20.972 1.134 30.278 7.44 30.278 7.161 0-.089.03-.446.089-1.07.21-2.202.42-5.512.633-9.93C82.559 51.779 57.107 38.702 54 37z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5,
    cy: 41,
    fill: "#40516F",
    rx: 2.5,
    ry: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAA9E",
    fillRule: "nonzero",
    d: "M29.44 36.567l.675 20.315C12.47 60.122 1.577 67.455.903 66.977L0 56.443c1.833-2.459 26.806-18.2 29.44-19.876z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspectIntermediate);
export default __webpack_public_path__ + "static/media/prospect-intermediate.656af0234c44da14269766c837b080c6.svg";
export { ForwardRef as ReactComponent };